import { Navigate } from 'react-router-dom';
import { useAuth } from 'sections/authentication/context/UseAuth';

interface Props {
  allowedRoles: string[];
  children: React.ReactNode;
}

export default function RoleBasedRoute({ allowedRoles, children }: Props) {
  const { user, hasRole, isLoading } = useAuth();

  if (isLoading) return null;

  // User not logged in
  if (!user) return <Navigate to="/login" />;

  // User has required role?
  if (!hasRole(allowedRoles)) {
    return <Navigate to="/not-found" replace />;
  }

  return <>{children}</>;
}
